import { ErpPartnersActs } from "src/entities/erpPartnersActs/ui/ErpPartnersActs";

export const ErpPartnersActsPage = () => {
  return <ErpPartnersActs />;
};
